var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3526",
    "data-name": "Group 3526",
    transform: "translate(-218 -664)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2192",
    "data-name": "Rectangle 2192",
    width: 14,
    height: 14,
    transform: "translate(218 664)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_outline-link",
    d: "M9.833,4.667H7.567V5.8H9.833a1.7,1.7,0,0,1,0,3.4H7.567v1.133H9.833a2.833,2.833,0,0,0,0-5.667ZM6.433,9.2H4.167a1.7,1.7,0,1,1,0-3.4H6.433V4.667H4.167a2.833,2.833,0,1,0,0,5.667H6.433Zm-1.7-2.267H9.267V8.067H4.733Z",
    transform: "translate(218 663.5)",
    fill: "#4d6382"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkInactive);
export default __webpack_public_path__ + "static/media/link-inactive.c8da8a5137eef8344a6fbdadbcb713b8.svg";
export { ForwardRef as ReactComponent };